import axios from "axios";
import router from "@/router";
import { Notification, Loading } from "element-ui";
import i18n from "@/i18n";
import store from "@/store";

// 创建一个 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 60000, // 请求超时时间
});

let loadingInstance; // 用于存储Loading实例

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    if (config.showLoading !== false) {
      loadingInstance = Loading.service({
        lock: true,
        fullscreen: true,
        text: i18n.t("main.loading_text"),
        spinner: "el-icon-loading",
        customClass: "my-custom-loading",
      });
    }

    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = "Token " + token;
    }
    return config;
  },
  (error) => {
    if (loadingInstance) {
      loadingInstance.close();
    }
    console.error(error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    if (loadingInstance) {
      loadingInstance.close();
      loadingInstance = null;
    }

    // 检查响应数据是否为 Blob 类型 (这意味着它是一个文件下载请求)。
    // 并且确认原始请求就是期望一个 blob，这让判断更严谨。
    if (
      response.data instanceof Blob &&
      response.request.responseType === "blob"
    ) {
      // 如果是文件，则不进行 JSON 格式的业务逻辑判断，直接返回完整的 response 对象。
      // 返回完整 response 是因为业务代码需要从 response.headers 中获取文件名。
      return response;
    }

    const res = response.data;

    if (!res.success) {
      let message = "";
      const errorCode = res.error_code;
      // 动态构建 i18n key, 例如 "errors.2007"
      const errorCodeKey = `error.${errorCode}`;

      if (errorCode && i18n.t(errorCodeKey)) {
        message = i18n.t(errorCodeKey);
      } else {
        message = i18n.t("error.unknown");
      }

      Notification.error({
        title: i18n.t("error.errorTitle"),
        message: message,
      });

      // 根据 error_code 处理特殊情况，例如 token 失效
      if (res.error_code === 1001) {
        // 调用 Vuex action 来处理登出逻辑
        store.dispatch("logout");

        // 在跳转前检查当前路由是否已经是目标路由
        if (router.currentRoute.path !== "/") {
          router.push("/");
        }
      }

      // 将业务错误包装成一个Error对象并拒绝Promise，以便业务代码中的catch可以捕获
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      // 如果 success 为 true，直接返回后端返回的完整数据
      return res;
    }
  },
  (error) => {
    // 关闭loading
    if (loadingInstance) {
      loadingInstance.close();
      loadingInstance = null;
    }
    console.error("err" + error);

    // 处理网络错误或服务器错误 (HTTP 状态码非 2xx)
    Notification.error({
      title: i18n.t("error.networkErrorTitle"),
      message: i18n.t("error.networkErrorMsg"),
    });

    return Promise.reject(error);
  }
);

export default service;
